import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Heart } from 'lucide-react';
import { CONTACT, SERVICES } from '../../data/mock';

const Footer = () => {
  return (
    <footer className="border-t border-white/10 mt-16 text-white backdrop-blur-xl" style={{
      background: 'linear-gradient(to right, rgba(76, 51, 98, 0.95) 0%, rgba(76, 51, 98, 0.85) 30%, rgba(76, 51, 98, 0.75) 60%, rgba(76, 51, 98, 0.65) 100%)'
    }}>
      <div className="container">
        {/* Main Footer */}
        <div className="py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Brand Column */}
            <div className="lg:col-span-1">
              <Link to="/" className="inline-flex items-center mb-4">
                <div className="transition-all hover:scale-105">
                  <img
                    src="/logo.png"
                    alt="Great Engineers Logo"
                    className="h-16 w-16 object-contain drop-shadow-2xl"
                  />
                </div>
                <span className="text-white font-bold text-2xl tracking-tight drop-shadow-lg">
                  Great Engineers
                </span>
              </Link>
              <p className="text-white/80 text-sm leading-relaxed mb-3 font-medium">
                Engineering scalable full-stack applications with 15+ years of elite expertise.
                From React frontends to Node backends, delivering solutions that define excellence.
              </p>
              <a
                href={`mailto:${CONTACT.email}`}
                className="text-teal-300 font-bold text-sm hover:text-teal-200 hover:underline inline-block transition-colors"
              >
                {CONTACT.email}
              </a>
            </div>

            {/* Services Column */}
            <div>
              <h4 className="font-bold text-white mb-4 text-base">Services</h4>
              <ul className="space-y-2">
                {SERVICES.slice(0, 5).map((service) => (
                  <li key={service.id}>
                    <Link
                      to={`/services/${service.slug}`}
                      className="text-sm text-white/70 font-medium hover:text-teal-300 transition-colors flex items-center gap-2 group"
                    >
                      <span className="w-1.5 h-1.5 rounded-full bg-teal-400"></span>
                      {service.title}
                      <ArrowUpRight className="w-3 h-3 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Additional Services Column */}
            <div>
              <h4 className="font-bold text-white mb-4 text-base">Specializations</h4>
              <ul className="space-y-2">
                {SERVICES.slice(5).map((service) => (
                  <li key={service.id}>
                    <Link
                      to={`/services/${service.slug}`}
                      className="text-sm text-white/70 font-medium hover:text-teal-300 transition-colors flex items-center gap-2"
                    >
                      <span className="w-1.5 h-1.5 rounded-full bg-teal-400"></span>
                      {service.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Quick Links Column */}
            <div>
              <h4 className="font-bold text-white mb-4 text-base">Company</h4>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-white/70 font-medium hover:text-teal-300 transition-colors flex items-center gap-2"
                  >
                    About Us
                  </Link>
                </li>
                <li>
                  <Link
                    to="/case-studies"
                    className="text-sm text-white/70 font-medium hover:text-teal-300 transition-colors flex items-center gap-2"
                  >
                    Case Studies
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact"
                    className="text-sm text-white/70 font-medium hover:text-teal-300 transition-colors flex items-center gap-2"
                  >
                    Contact
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-4 border-t border-white/10">
          <div className="text-center">
            <p className="text-sm text-white/70 font-medium flex items-center justify-center gap-1">
              <span>© {new Date().getFullYear()} hire-fullstack-engineers.com. All rights reserved.</span>
              <span className="hidden md:inline mx-1">|</span>
              <span className="block md:inline w-full md:w-auto mt-2 md:mt-0">
                Powered by{' '}
                <a
                  href="https://www.prosperasoft.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-teal-400 hover:underline font-medium transition-colors"
                >
                  Prosperasoft
                </a>
              </span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;